const state = {
  revalidatePassword: false,
  showPasswordMatchWarning: false
}

const getters = {
  getRevalidatePassword: (state) => { return state.revalidatePassword },
  getShowPasswordMatchWarning: (state) => { return state.showPasswordMatchWarning }
}

const actions = {
}

const mutations = {
  setRevalidatePassword (state, value) {
    state.revalidatePassword = value
  },
  setShowPasswordMatchWarning (state, value) {
    state.showPasswordMatchWarning = value
  }
}

export const module = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/Store/modules/userInformationModule.js